<template>
<div class="dsb-router-wrapper">
    <div class="dsb-router-header">
        <div class="dsb-title dsb-title-lg">
            <p>Wo sind deine Daten?</p>
        </div>
    </div>
    <Loader v-if="loading" />
    <div v-else>
        <div class="stats">
            <p @click="filterByStatus(null)" :class="{ active: activeStatus === null }">
                Alle <span>{{ statusCounts.all }}</span>
            </p>

            <p><b>|</b></p>

            <p @click="filterByStatus(1)" :class="{ active: activeStatus === 1 }">
                In Bearbeitung <span>{{ statusCounts.inBearbeitung }}</span>
            </p>

            <p><b>|</b></p>

            <p @click="filterByStatus(3)" :class="{ active: activeStatus === 3 }">
                Antwort <span>{{ statusCounts.antwort }}</span>
            </p>

            <p><b>|</b></p>

            <p @click="filterByStatus(4)" :class="{ active: activeStatus === 4 }">
                Wird gelöscht <span>{{ statusCounts.wirdGeloescht }}</span>
            </p>

            <p><b>|</b></p>

            <p @click="filterByStatus(5)" :class="{ active: activeStatus === 5 }">
                Abgeschlossen <span>{{ statusCounts.abgeschlossen }}</span>
            </p>
        </div>

        <div class="details-table" v-if="filteredTickets && filteredTickets.length > 0">
            <div class="header">
                <div class="header-el el-sm"></div>
                <div class="header-el el-lg">
                    <p>Unternehmen</p>
                </div> 
                <div class="header-el el-sm" v-if="!mobile">
                    <p>Risiko</p>
                </div> 
                <div class="header-el el-lg">
                    <p>Status</p>
                </div> 
            </div>

            <div class="body"> 
                <div v-for="request in filteredTickets" :key="request.id" class="row">
                    <div class="row-wrapper">
                        <div class="row-el el-sm expand-btn" @click="toggleRow(request.id)">
                            <img v-if="expandedRows === request.id" src="../../assets/icons/up.svg" />
                            <img v-else src="../../assets/icons/down.svg" />
                        </div>
                        <div class="row-el el-lg">
                            <div class="pursue">
                                <p>{{request.company.name}}</p>
                            </div>
                        </div> 
                        <div class="row-el el-sm" v-if="!mobile">
                            <div class="risk-icon">
                                <img :src="getRiskIcon(request.company.riskCount)" alt="Risk Icon" />
                            </div>
                        </div> 
                        <div class="row-el el-lg ">
                            <div :class="['status', getStatusClass(request.status.id)]"> 
                                <p>{{ request.status.name }}</p>
                            </div>
                        </div> 
                    </div>

                    <transition @before-enter="beforeEnter" @enter="enter" @before-leave="beforeLeave" @leave="leave">
                        <div v-if="expandedRows === request.id" class="row-expanded">

                            <div v-if="mobile">
                                <div class="header"> 
                                    <div class="header-el el-sm">
                                        <p>Risiko</p>
                                    </div> 
                                </div>
                                <div class="row-wrapper">
                                    
                                    <div class="row-el el-sm">
                                        <div class="risk-icon">
                                            <img :src="getRiskIcon(request.company.riskCount)" alt="Risk Icon" />
                                        </div>
                                    </div> 
                                </div>
                            </div>

                            <div class="row-expanded-content">
                                <div class="content-wrapper">
                                    <div class="dsb-title dsb-title-ss">
                                        <p>Anforderungsstatus</p>
                                    </div>
                                </div>

                                <div class="progress-bar-container">
                                    <div class="progress-bar">

                                        <div class="progress-fill" :class="'progress-fill-'+request.status.id">
                                            <div class="progress-ball"></div>
                                        </div>
                                    </div>
                                </div>

                                <div class="statuses-list">
                                    <div v-for="(status, index) in sliderStatuses" :key="index" :class="'status status' + (index + 1)"> 
                                          <p>{{ status.label }}</p> 
                                    </div>
                                </div>

                                <div class="content-wrapper">
                                    <div class="dsb-title dsb-title-ss">
                                        <p>Allgemeine Statistiken</p>
                                    </div>

                                    <div class="request-dates">
                                        <div class="request-sent">
                                            <p>Letzte Anfrage gesendet</p>
                                            <p>{{ request.openDate }}</p>
                                        </div>
                                        <div class="request-completed">
                                            <p>Letzte Änderung</p>
                                            <p>{{ request.latestUpdateDate }}</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="content-wrapper">
                                    <div class="dsb-title dsb-title-ss">
                                        <p>Über {{request.company.name}}</p>
                                    </div>

                                    <div class="about-data">
                                        <p>{{ request.company.aboutData }}</p>
                                    </div>
                                </div>

                                <div class="content-wrapper">
                                    <div class="dsb-title dsb-title-ss">
                                        <p>Verbundene Risiken</p>
                                    </div>

                                    <div class="risks-list">
                                        <div class="risk" v-for="risk in request.company.risks" :key="risk">
                                            <p>{{ risk }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </transition>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="dsb-title dsb-title-sm no-ticktes">
                <p>Es gibt keine Tickets</p>
            </div>
        </div>
    </div> 
</div>
</template>

<script>
import Loader from '../../components/Loader.vue';

export default {
    components: {
        Loader
    },
    data() {
        return {
            // ticktes: {},

            ticktes: [], // changed {} → [] for array usage
            filteredTickets: [], // for showing filtered results
            activeStatus: null,

            expandedRows: {},
            mobile: false,

            loading: false,

            sliderStatuses: [{
                    id: 1,
                    label: "In Bearbeitung"
                },
                {
                    id: 2,
                    label: "Angefragt"
                },
                {
                    id: 3,
                    label: "Antwort"
                },
                {
                    id: 4,
                    label: "Wird gelöscht"
                },
                {
                    id: 5,
                    label: "Abgeschlossen"
                },
            ]
        }
    },
    computed: {
        // ✅ Count tickets per status
        statusCounts() {
            const counts = {
                all: this.ticktes.length,
                inBearbeitung: 0,
                angefragt: 0,
                antwort: 0,
                wirdGeloescht: 0,
                abgeschlossen: 0,
            };

            this.ticktes.forEach(ticket => {
                switch (ticket.status.id) {
                case 1: counts.inBearbeitung++; break;
                case 2: counts.angefragt++; break;
                case 3: counts.antwort++; break;
                case 4: counts.wirdGeloescht++; break;
                case 5: counts.abgeschlossen++; break;
                }
            });

            return counts;
        }
    },
    methods: {

        checkIfMobile() {
            this.mobile = window.innerWidth <= 1000;
        },

        toggleRow(id) {
            this.expandedRows = this.expandedRows === id ? null : id;
        },

        beforeEnter(el) {
            el.style.height = '0';
        },
        enter(el) {
            el.style.transition = 'height 0.3s ease-out, opacity 0.3s ease-out';
            el.style.height = el.scrollHeight + 'px';
            el.style.opacity = '1';
        },
        beforeLeave(el) {
            el.style.height = el.scrollHeight + 'px';
        },
        leave(el) {
            el.style.transition = 'height 0.3s ease-in, opacity 0.2s ease-in';
            el.style.height = '0';
            el.style.opacity = '0';
        },

        getRiskIcon(riskCount) {
            if (riskCount === 1) {
                return require('../../assets/icons/very_low_emoji.svg');
            } else if (riskCount === 2) {
                return require('../../assets/icons/low_emoji.svg');
            } else if (riskCount === 3) {
                return require('../../assets/icons/medium_emoji.svg');
            } else if (riskCount >= 4) {
                return require('../../assets/icons/high_emoji.svg');
            }
        },

        getStatusClass(statusId) {
            switch (statusId) {
                case 1:
                    return 'in-progress-status';
                case 2:
                    return 'requested-status';
                case 3:
                    return 'answered-status';
                case 4:
                    return 'will-be-deleted-status';
                case 5:
                    return 'completed-status';
                case 6:
                    return 'retain-data-status';    
                case 7:
                    return 'deleted-status';
                case 9:
                    return 'deleted-status';
            }
        },

        filterByStatus(statusId) {
            this.loading = true;

            setTimeout(() => {
                if (this.activeStatus === statusId) {
                    this.activeStatus = null;
                    this.filteredTickets = this.ticktes;
                    return;
                }

                this.activeStatus = statusId;
                this.filteredTickets = statusId
                    ? this.ticktes.filter(t => t.status.id === statusId)
                    : this.ticktes;
 
                this.loading = false;
            }, "500"); 
        },
    },
    async mounted() {
        this.loading = true;
        const isVerified = await this.checkUserIdentity();

        if (isVerified) {
            await this.getTicketsData();
            this.ticktes = this.ticketsData.data.data;

            if(this.ticktes.length == 0 ){ 
                await this.requestCleanData();
                 await this.getTicketsData();
                this.ticktes = this.ticketsData.data.data;
            }  

            this.filteredTickets = this.ticktes;
        }

        this.checkIfMobile();

        window.addEventListener("resize", this.checkIfMobile);

        this.loading = false;
    },

//     async mounted() {
//     this.loading = true;
//     const isVerified = await this.checkUserIdentity();

//     if (isVerified) {
//         const success = await this.getTicketsData();

//         if (!success) {
//             // show modal if fetching tickets failed
//             this.$store.commit("application/setErrorProcessModal", true);
//             this.$store.commit("application/setErrorProcessTitle", "Fehler beim Laden der Tickets!");
//             this.$store.commit("application/setErrorProcessText", this.ticketsError || "Ein unerwarteter Fehler ist aufgetreten.");
//             this.loading = false;
//             return; // stop further processing
//         }

//         this.ticktes = this.ticketsData.data.data;

//         if (this.ticktes.length == 0) {
//             await this.requestCleanData();
//             await this.getTicketsData();
//             this.ticktes = this.ticketsData.data.data;
//         }
//     }

//     this.checkIfMobile();
//     window.addEventListener("resize", this.checkIfMobile);

//     this.loading = false;
// },

    beforeUnmount() {
        window.removeEventListener("resize", this.checkIfMobile);
    },
}
</script>

<style lang="scss" scoped>

.stats{ 
    width: 100%;
    display: flex;
    gap: 10px; 

    p{
        font-size: 16px;
        cursor: pointer;
        color: #FA3A67;

        span{
            color: #3C3C3C;
        }

        &.active {
            font-weight: bold; 
            text-decoration: underline;
            text-decoration-thickness: 2px;    
            text-underline-offset: 5px; 
        }
    }  
}

.no-ticktes{
    height: 30vh;
    display: flex;
    align-items: center;
    justify-content: center;
}

.expand-btn {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
        width: 30%;
    }
}

.progress-bar-container {
    width: 100%;
    padding: 10px 0;
}

.progress-bar {
    width: 100%;
    height: 20px;
    background: #D3D3D380;
    border-radius: 50px;
    position: relative;
    box-shadow: 8px 6px 20px #56597A4D;
}

.progress-fill {
    height: 100%;
    width: 0%;
    background: #FF3A67;
    border-radius: 50px;
    transition: width 0.3s ease-in-out;
    position: relative;
}

.progress-ball {
    width: 38px;
    height: 38px;
    background: #FF3A67;
    border-radius: 50%;
    position: absolute;
    right: -10px;
    top: 50%;
    transform: translateY(-50%);
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

.statuses-list {
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    .status {
        width: 25%;
        text-align: center;

        p {
            color: #000000;
            font-size: 18px;
        }
    }

    .status1 {
        text-align: left;
    }

    .status5 {
        text-align: right;
    }
}

.progress-fill-1 {
    width: 7%;
}

.progress-fill-2 {
    width: 31%;
}

.progress-fill-3 {
    width: 51%;
}

.progress-fill-4 {
    width: 71%;
}

.progress-fill-5 {
    width: 100%;
}

@import "../../assets/dashboard.scss";

.el-sm {
    flex: 1;
}

.el-md {
    flex: 2;
}

.el-lg {
    flex: 3;
}

.details-table {
    margin-top: 80px;

    .header {
        padding: 0 10px;
        padding-bottom: 30px;

        display: flex;
        justify-content: space-between;

        .header-el {
            text-align: center;

            p {
                color: #000000;
                font-weight: 500;
                font-size: 16px;
            }
        }
    }

    .body {
        .row-wrapper {
            border: 1px solid transparent;
            border-top-color: #7070704d;
            padding: 30px 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .row-el {
                text-align: center;
            }
        }

        .row-expanded {
            overflow: hidden;
            opacity: 0;
            transition: opacity 0.3s ease;
            width: 100%;

            .row-expanded-content {
                padding: 30px 4%;
                padding-top: 10px;
                width: 100%;
                border: 1px solid transparent;
                border-top-color: #FA3A67;

                .content-wrapper {
                    margin-bottom: 20px;
                }
            }
        }
    }
}

.dsb-title {
    margin-bottom: 15px;
}

.request-dates {
    display: flex;
    gap: 65px;
    align-items: center;

    p {
        font-size: 16px;
        color: #56597A;

        &:first-child {
            margin-bottom: 5px;
        }
    }
}

.about-data {
    p {
        font-size: 16px;
        color: #56597A;
    }
}

.risks-list {
    display: flex;
    flex-wrap: wrap;
    gap: 30px;
    align-items: center;

    .risk {
        p {
            color: #FFFFFF;
            font-size: 16px;
        }

        padding: 5px 20px;
        background-color: #3C3C3C65;
        box-shadow: 4px 6px 14px #56597A4D;
        border-radius: 20px;
        margin: initial !important;
        width: auto;

        display: flex;
        align-items: center;
    }
}

/* Inner content padding */

.risk-icon {
    width: 35px;
    height: 35px;
    margin: 0 auto;

    img {
        width: 100%;
    }
}

.pursue,
.issue,
.request {
    p {
        font-size: 16px;
    }
}

.pursue,
.request {
    p {
        color: #000000;
    }
}

.issue {
    p {
        color: #56597A;
    }
}

.status {
    width: 160px;
    padding: 10px 0;
    margin: 0 auto;
    border-radius: 20px;

    p {
        font-size: 14px;
        font-weight: bold;
    }
}

.in-progress-status, .requested-status {
    color: #F68525;
    border: 1px solid #F68525;
}

.answered-status {
    color: #557BEA;
    border: 1px solid #557BEA;
}

.will-be-deleted-status {
    color: #FA3A67;
    border: 1px solid #FA3A67;
}

.completed-status, .deleted-status {
    color: #39E23E;
    border: 1px solid #39E23E;
}

.retain-data-status {
    color: #9F9F9F;
    border: 1px solid #9F9F9F;
}

 

/* imac 24" */
/* 2048 x 1152 */
@media (min-width: 2048px) {}

/* 2304-1470 */
@media (min-width: 2304px) {
    .risk-icon {
        width: 40px;
        height: 40px;
    }
}

/* 2470 - 1328 */
@media (min-width: 2470px) {
    .stats{    
        p{
            font-size: 18px;  
        }  
    }

    .details-table .header .header-el p {
        font-size: 18px;
    }

    .pursue p,
    .issue p,
    .request p {
        font-size: 18px;
    }

    .status {
        width: 180px;

        p {
            font-size: 16px;
        }
    }

    .statuses-list .status p {
        font-size: 20px;
    }

    .progress-bar {
        height: 25px;
    }

    .progress-ball {
        width: 42px;
        height: 42px;
    }
}

/* imac retina */
/*2560-1440*/
@media (min-width: 2560px) {
    .stats{  
        gap: 15px; 

        p{
            font-size: 20px;
            &.active { 
                text-underline-offset: 10px;  
            }  
        }  
    }

    .risk-icon {
        width: 45px;
        height: 45px;
    }

    .details-table .body .row-expanded .row-expanded-content {
        padding-top: 20px;
    }

    .dsb-title {
        margin-bottom: 25px;
    }

    .details-table .body .row-expanded .row-expanded-content .content-wrapper {
        margin-bottom: 30px;
    }

    .request-dates p {
        font-size: 18px;
    }

    .about-data p {
        font-size: 18px;
    }

    .risks-list .risk p {
        font-size: 18px;
    }
}

/*2573-1206*/
@media(min-width: 2573px) {}

/* 2880-1670 */
@media(min-width: 2880px) {
    .stats{  
        gap: 18px; 

        p{
            font-size: 22px;  
        }  
    }

    .details-table .header .header-el p {
        font-size: 20px;
    }

    .pursue p,
    .issue p,
    .request p {
        font-size: 20px;
    }

    .status {
        width: 200px;
        padding: 12px 0;

        p {
            font-size: 18px;
        }
    }

    .statuses-list .status p {
        font-size: 22px;
    }

    .progress-bar {
        height: 30px;
    }

    .progress-ball {
        width: 46px;
        height: 46px;
    }
}

/* 3000-1870 */
@media(min-width: 3000px) {}

/*3200-1800*/
@media(min-width: 3200px) {
    .stats{  
        gap: 18px; 

        p{
            font-size: 22px;  
        }  
    }

    .risk-icon {
        width: 50px;
        height: 50px;
    }

    .details-table .body .row-expanded .row-expanded-content {
        padding: 40px 4%;
        padding-top: 30px;
    }

    .dsb-title {
        margin-bottom: 30px;
    }

    .details-table .body .row-expanded .row-expanded-content .content-wrapper {
        margin-bottom: 40px;
    }

    .request-dates p {
        font-size: 20px;
    }

    .about-data p {
        font-size: 20px;
    }

    .risks-list {
        .risk {
            padding: 8px 25px;

            p {
                font-size: 20px;
            }
        }
    }

    .details-table .header .header-el p,
    .pursue p,
    .issue p,
    .request p {
        font-size: 22px;
    }

    .status p {
        font-size: 20px;
    }

    .statuses-list .status p {
        font-size: 24px;
    }

    .progress-bar {
        height: 35px;
    }

    .progress-ball {
        width: 50px;
        height: 50px;
    }
}

/*3360-1890 1695*/
@media(min-width:3360px) {}

/* 3840 x 2160 2049 (4K) */
@media(min-width:3840px) {
    .stats{  
        gap: 20px; 

        p{
            font-size: 26px;  
        }  
    }

    .details-table .header .header-el p {
        font-size: 24px;
    }

    .pursue p,
    .issue p,
    .request p {
        font-size: 24px;
    }

    .status {
        width: 240px;

        p {
            font-size: 24px;
        }
    }

    .risk-icon {
        width: 55px;
        height: 55px;
    }

    .details-table .body .row-expanded .row-expanded-content {
        padding: 50px 4%;
        padding-top: 40px;
    }

    .dsb-title {
        margin-bottom: 40px;
    }

    .details-table .body .row-expanded .row-expanded-content .content-wrapper {
        margin-bottom: 50px;
    }

    .request-dates p {
        font-size: 26px;
    }

    .about-data p {
        font-size: 26px;
    }

    .details-table .header .header-el p,
    .pursue p,
    .issue p,
    .request p {
        font-size: 26px;
    }

    .risks-list .risk p {
        font-size: 24px;
    }

    .statuses-list .status p {
        font-size: 28px;
    }

    .progress-bar {
        height: 45px;
    }

    .progress-ball {
        width: 65px;
        height: 65px;
    }
}

/* 1920x961 (current) */

/* macbook pro 16 2021 */
/*1728x1085*/
@media(max-width: 1728px) {
    .dsb-router-wrapper {
        padding: 80px 110px;
    }

    .expand-btn img {
        height: 30px;
        width: 30px;
    }

    .risk-icon {
        width: 30px;
        height: 30px;
    }

    .progress-bar {
        height: 15px;
    }

    .progress-ball {
        width: 30px;
        height: 30px;
    }

    .statuses-list .status p {
        font-size: 16px;
    }

    .dsb-title-ss p {
        font-size: 18px;
    }
}

/*1688-1080*/
@media(max-width: 1688px) {}

/*1680-1080*/
@media(max-width: 1680px) {}

/*1640-1080*/
@media(max-width: 1640px) {
    .dsb-router-wrapper {
        padding: 70px 90px;
    }

    .details-table {

        .header {
            padding: 0px;
            padding-bottom: 24px;

            .header-el p {
                font-size: 14px;
            }
        }

        .body .row-wrapper {
            padding: 24px 0px;
        }
    }

    .dsb-title-ss p {
        font-size: 16px;
    }

    .expand-btn img {
        height: 25px;
        width: 25px;
    }

    .risk-icon {
        height: 25px;
        width: 25px;
    }

    .pursue p,
    .issue p,
    .request p {
        font-size: 14px;
    }

    .status {
        width: 145px;
    }

    .request-dates p {
        font-size: 14px;
    }

    .about-data p {
        font-size: 14px;
    }

    .risks-list .risk p {
        font-size: 14px;
    }

    .statuses-list .status p {
        font-size: 14px;
    }

    .status {
        padding: 8px 0;
    }

    .progress-ball {
        width: 25px;
        height: 25px;
    }
}

/* 1600 - 757 */
@media (max-width: 1600px) {}

/*1536-864*/
@media(max-width:1536px) {
    .stats p {
        font-size: 14px;
    }

    .dsb-router-wrapper {
        padding: 60px 70px;
    }

    .status {
        padding: 6px 0;
    }

    .risks-list .risk {
        padding: 3px 18px;
    }
}

/* macbook pro/air */
/* 1440-900 */
@media(max-width:1440px) {

    .status {
        width: 130px;

        p {
            font-size: 12px;
        }
    }
}

/*1366-638*/
@media (max-width:1366px) {
    .dsb-router-wrapper {
        padding: 50px;
    }

    .details-table {
        margin-top: 60px;
    }
}

/* macbook air */
/* 1280-800 */
@media (max-width:1280px) {}

/* 1200-1920 */
@media (max-width:1200px) {

    .details-table .body .row-expanded .row-expanded-content {
        padding: 10px 2%;
    }

    .risks-list {
        gap: 20px;
    }
}

/*1134x712*/
@media(max-width:1134px) {
    .dsb-router-wrapper {
        padding: 40px;
    }
}

/* tablets */

/* micro duo */
/*1114x705*/
@media(max-width:1114px) {
    .dsb-router-wrapper {
        padding: 40px 10px;
    }
}

/*1024-768*/
/* ipad pro */
/*1024-1366*/
@media (max-width:1024px) {}

/* ipad pro 2/3 */
/* 981x1024 */
@media (max-width:981px) {}

/* 962x601 */
@media(max-width: 962px) {}

/* 900x1600 */
@media(max-width: 900px) {}

/* galaxy fold */
/* 884 x 1104 */
@media(max-width: 884px) {
    .details-table .body .row-expanded .row-expanded-content {
        padding: 10px 3%;
    }
}

/* ipad pro 2022 */
/*834-1136*/
@media(max-width: 834px) {
    .statuses-list .status p {
        font-size: 12px;
    }
}

/* ipad air 4 */
/* 820x1180 */
@media(max-width: 820px) {}

/* ipad 2020 */
/* 810x1080 */
@media(max-width: 810px) {
    .stats { 
        gap: 8px;
    }
}

/* galaxy tab 7 */
/* 800x1280 */
@media(max-width: 800px) {
    .stats { 
        gap: 5px;
    }
}

/*778-304*/
@media(max-width: 778px) {}

/*775*/
@media(max-width: 775px) {}

/* ipad air/mini */
/* 768x1024 */
@media(max-width: 768px) {
    .stats { 
        gap: 3px;
         
        p {
        font-size: 13px;
    }
}
}

/*712-1138*/
@media(max-width:712px) {
    .stats p {
        font-size: 12px;
    } 
}

/* ipad air 2/3 */
/* 694-768 */
@media(max-width:694px) {
    .stats {
        gap: 8px;
        
        p {
            font-size: 14px;
        }
    }
}

/* ipad pro 1/2 */
/* 678-1024 */
@media(max-width:678px) {}

/* 600x962 */
@media(max-width:600px) {}

/* 577-951 */
@media(max-width:577px) {
    .stats { 
        flex-wrap: wrap;
        p {
            font-size: 13px;
        }
    }

    .statuses-list .status p {
        font-size: 10px;
    }
}

/* 540-960 */
@media(max-width:540px) {
    .details-table .body .row-expanded .row-expanded-content {
        padding: 10px 0;
        width: 94%;
        margin: 0 auto;
    }
}

/* mobiles */

/* s-note */
/*480-853*/
@media (max-width:480px) {
    .stats {  
        gap: 15px 6px;

        p {
            font-size: 12px;
        }
    }

    .progress-bar {
        height: 10px;
    }

    .dsb-router-wrapper {
        padding-top: 60px;
    }

    .details-table {
        margin-top: 40px;
    }
}

/* ipad air 2/3 */
/*438-1024*/
@media(max-width:438px) {
    .expand-btn img {
        height: 20px;
        width: 20px;
    } 
}

/* ip14 pro max */
/* 430x932 */
@media(max-width:430px) {
    .progress-ball {
        width: 20px;
        height: 20px;
    } 
}

/* ip13 pro max */
/* 428-926 */
@media (max-width:428px) {}

/* ip11 pro max */
/* 414-896/736*/
@media (max-width:414px) {
    .request-dates {
        gap: 40px;
    }
}

/* s21 ultra, pix6 */
/* 412-915*/
/* heights: 732, 824, 846, 869, 892, 906, 915, 919 */
@media (max-width:412px) {}

/* ip14 pro, pix5 */
/*393 x 852*/
@media(max-width:393px) {
    .details-table .header {
        padding-bottom: 15px;
    }

    .details-table .body .row-wrapper {
        padding: 20px 0px;
    }

    .statuses-list .status p {
        font-size: 8px;
    }

    .dsb-title-ss p {
        font-size: 14px;
    }

    .status {
        padding: 4px 0;
    }

    .pursue p,
    .issue p,
    .request p,
    .request-dates p,
    .risks-list .risk p {
        font-size: 12px;
    }
}

/* ip13 pro */
/*390 x 844*/
@media(max-width:390px) {}

/* s21 plux */
/*384-854*/
@media(max-width:384px) {}

/* ip X */
/*375-812/667*/
@media(max-width:375px) {}

/* s22 ultra */
/*360x772*/
@media(max-width:360px) {}

/* ip SE */
/*320x568*/
@media(max-width:320px) {}
</style>
